import { createStore } from 'vuex'

import modules from './modules'

export default createStore({
  modules,
  actions: {
    reset ({ commit }) {
      // resets state of all the modules
      Object.keys(modules).forEach(moduleName => {
        commit(`${moduleName}/RESET`)
      })
    }
  }
})
